import { useLanguage } from '../context/LanguageContext';

// Flag images from flagcdn.com
const flagImages = {
  fr: 'https://flagcdn.com/24x18/fr.png',
  en: 'https://flagcdn.com/24x18/gb.png',
  es: 'https://flagcdn.com/24x18/es.png',
  de: 'https://flagcdn.com/24x18/de.png',
  it: 'https://flagcdn.com/24x18/it.png',
  nl: 'https://flagcdn.com/24x18/nl.png',
  ru: 'https://flagcdn.com/24x18/ru.png',
  ar: 'https://flagcdn.com/24x18/sa.png',
  zh: 'https://flagcdn.com/24x18/cn.png',
  ja: 'https://flagcdn.com/24x18/jp.png',
  ko: 'https://flagcdn.com/24x18/kr.png',
  hi: 'https://flagcdn.com/24x18/in.png',
};

export function LanguageSelector() {
  const { language, setLanguage, languages } = useLanguage();

  return (
    <div className="flex items-center gap-1" data-testid="language-selector">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          className={`p-1 rounded transition-all hover:scale-110 ${
            language === lang.code 
              ? 'ring-2 ring-accent ring-offset-1' 
              : 'opacity-70 hover:opacity-100'
          }`}
          aria-label={lang.name}
          title={lang.name}
          data-testid={`lang-${lang.code}`}
        >
          <img 
            src={flagImages[lang.code]} 
            alt={lang.name} 
            className="w-5 h-4 object-cover rounded-sm"
          />
        </button>
      ))}
    </div>
  );
}
